import './bootstrap';
import '../css/app.css';

import React from 'react';
import { render } from 'react-dom';
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import i18next from './i18n';
import 'react-datepicker/dist/react-datepicker.css'

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

Bugsnag.start({
    apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()]
})

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx')),
    setup({ el, App, props }) {
        i18next.changeLanguage(props.initialPage?.props?.auth?.user?.language || 'en');

        const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
        //return render(<ErrorBoundary><App {...props} /></ErrorBoundary>, el);

        render(React.createElement(
            ErrorBoundary,
            null,
            React.createElement(App, props)
        ), el);
    },
    progress: {
        color: '#4B5563',
    },
});

//InertiaProgress.init({ color: '#4B5563' });
